<template>
  <el-dialog
    :append-to-body="true"
    :title="$t('开始生产')"
    width="60%"
    :visible.sync="dialog.visible"
  >
    <div v-for="order in itemJson" :key="order.id">
        <div class="border-tb p-2">
            <div class="d-flex pd-x-5 flex-1 mb-2 f-bold">
                <div class="c-5">{{ $t("rm.订单编号") }}</div>
                <div class="c-4">{{ $t("rm.SKU名称") }}</div>
                <div class="c-4">{{ $t("rm.SKU") }}</div>
                <div class="c-6">{{ $t("rm.数量") }}</div>
                <div class="c-5">{{ $t("rm.生产时间") }}</div>
            </div>
            <div class="d-flex pd-x-5 flex-1">
                <div class="c-5">{{dialog.data.code}}</div>
                <div class="c-4">
                    <el-tooltip effect="dark" :content="order.skuName" placement="bottom">
                        <div class="font-line">{{ order.skuName }}</div>
                    </el-tooltip>
                </div>
                <div class="c-4">
                    <el-tooltip effect="dark" :content="order.sku" placement="bottom">
                       <div class="font-line">{{ order.sku }}</div>
                    </el-tooltip>
                </div>
                <div class="c-6">
                    <div class="flex-box">
                        <input class="w form-control form-control-sm tx-13 mg-b-5" oninput="value=value.replace(/[^0-9]/g,'')" v-model="order.prepareNum" />
                        <span> / {{order.waitingNum}}</span>
                    </div>
                </div>
                <div class="c-5 d-flex">
                    <div class="flex-box">
                        <!-- <el-input class="w" size="mini" oninput="value=value.replace(/[^0-9]/g,'')" v-model="order.productionDuration"></el-input> -->
                        {{order.productionDuration}}
                        <span>{{ $t("rm.天") }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-2">{{ $t("rm.所需原料") }}：</div>
        <div class="mb-4">
            <div class="d-flex pd-x-5 flex-1 f-bold text-center">
                <div class="c-6 h">{{ $t("rm.名称") }}</div>
                <div class="c-6 h">{{ $t("rm.SKU") }}</div>
                <div class="c-6 h">{{ $t("rm.需要数量") }}</div>
                <div class="c-6 h">{{ $t("rm.当前库存数量") }}</div>
            </div>
            <div class="d-flex pd-x-5 flex-1 text-center" v-for="skus in order.raws" :key="skus.id">
                <div class="c-6 h">{{ skus.skuName }}</div>
                <div class="c-6 h">{{ skus.sku }}</div>
                <div class="c-6 h" :class="[Number(order.prepareNum) * Number(skus.num) > Number(skus.inventory) ? 'text-danger': '' ]">
                   {{(Number(order.prepareNum) * Number(skus.num)).toFixed(0)}}
                </div>
                <div class="c-6 h">
                    {{ Number(skus.inventory).toFixed(0) }}
                </div>
            </div>
        </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="confirm">{{ $t("rm.确认") }}</el-button>
      <el-button size="mini" @click="close">{{ $t("rm.关闭") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          visible: false,
          item: {},
          data: {},
        };
      },
    },
  },
  data() {
    return {
      // itemJson: this.dialog.data.itemJson || []
    };
  },
  computed: {
    itemJson() {
      let arr = this.dialog.data.itemJson || [];
      arr.forEach((element) => {
        this.$set(element, "prepareNum", element.waitingNum);
      });
      return arr;
    },
  },
  watch: {
    dialog: {
      deep: true,
      handler: function() {
        //   this.itemJson = (this.dialog.data.itemJson || []).forEach((ele) => {
        //     ele.prepareNum = ele.waitingNum
        // })
      },
    },
  },
  methods: {
    confirm() {
      let flag = false;
      for (let i = 0, len = this.dialog.data.itemJson.length; i < len; i++) {
        if (
          Number(this.dialog.data.itemJson[i].prepareNum) >
            Number(this.dialog.data.itemJson[i].waitingNum) ||
          this.dialog.data.itemJson[i].prepareNum === ""
        ) {
          ShowTip(this.$t("数量不可超过生产数量 && 不能为空"), "danger");
          flag = true;
          break;
        }
      }
      if (flag == true) {
        return;
      } else {
        let skuList = [];
        this.dialog.data.itemJson.forEach((item) => {
          skuList.push({ skuId: item.id, num: item.prepareNum });
        });
        let params = {
          orderId: this.dialog.data.id,
          skus: skuList,
        };
        $.api_call("api.Production.startProduction", params, (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("transfer.操作成功"), "success");
            this.$emit("close", true);
          } else {
            ShowTip(r.Message, "danger");
          }
        });
      }
    },
    close() {
      this.$emit("close", false);
    },
  },
};
</script>

<style scoped>
.flex-box {
  display: flex;
  align-items: center;
}
.font-line {
  /* // 单行文本出现省略号 */
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.w {
  width: 80px;
}
.h {
  height: 30px;
}
.border-tb {
  background: #eee;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.f-bold {
  color: rgb(87, 86, 86);
  font-weight: 600;
}
.border-red {
  border-radius: 4px;
  border: 1px solid red !important;
}
</style>
